import type { TranslationKey } from "../locales";
import type { Nullable, WebfleetObject } from "../types";

/**
 * This function returns the translation key for a given Webfleet object type.
 * @param type
 * @returns
 */
export function getWebfleetObjectTypeTranslationKey(
	type: Nullable<WebfleetObject["objecttype"]>,
): TranslationKey {
	if (!type) return "general.unknown";
	return `webfleet.vehicle_types.${type}` as TranslationKey;
}
